export const loadState = () => {
    try {
        const serializedState = sessionStorage.getItem('state');
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return undefined;
    }
};

export const saveState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        sessionStorage.setItem('state', serializedState);
    } catch {
        // ignore write errors
    }
};

export const loadToken = () => {
    return sessionStorage.getItem('token');
};

export const saveToken = (token) => {
    sessionStorage.setItem('token', token);
};

export const clearToken = () => {
    sessionStorage.removeItem('token');
};
